/**
 * Conditional Logger Utility
 *
 * Provides logging functions that only output in development mode.
 * In production, all logs are silenced to prevent information leakage
 * and improve performance.
 *
 * Usage:
 *   import logger from 'utils/logger';
 *   logger.log('Debug message', data);
 *   logger.error('Error message', error);
 *   logger.warn('Warning message');
 */

/* eslint-disable no-console */
// This file intentionally uses console methods - they are wrapped for conditional usage

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Log informational messages (development only)
   */
  log: (message, ...args) => {
    if (isDevelopment) {
      console.log(message, ...args);
    }
  },

  /**
   * Log error messages (development only)
   * Note: In production, critical errors should be sent to error tracking service
   */
  error: (message, ...args) => {
    if (isDevelopment) {
      console.error(message, ...args);
    }
    // TODO: In production, send to error tracking service (e.g., Sentry)
  },

  /**
   * Log warning messages (development only)
   */
  warn: (message, ...args) => {
    if (isDevelopment) {
      console.warn(message, ...args);
    }
  },

  /**
   * Log info messages (development only)
   */
  info: (message, ...args) => {
    if (isDevelopment) {
      console.info(message, ...args);
    }
  },
};

export default logger;
